export default "__VITE_ASSET__Mnt3yTT2__"